import { resolveExploreBounds } from "../utils/explore-bounds"

export default function initExploreBounds() {
  const { locationTrackerLatLng } = window.NaturkartanConfig || {}
  const { bounds, willAddBounds } = resolveExploreBounds(locationTrackerLatLng)

  document.body.addEventListener(
    `phoenix.link.click`,
    function (e) {
      if (!(`exploreBounds` in e.target.dataset)) return
      if (!willAddBounds) return

      e.preventDefault()
      const url = new window.URL(e.target.href)
      url.searchParams.set(`bounds`, bounds)

      window.liveSocket.historyRedirect(
        e,
        url.toString(),
        `push`,
        null,
        e.target
      )
    },
    false
  )
}
